"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampleAppUtilities = void 0;
var Config_1 = require("../../../app/Config");
var FaceTecSDK_1 = require("./../../../core-sdk/FaceTecSDK.js/FaceTecSDK");
var DeveloperStatusMessages_1 = require("./DeveloperStatusMessages");
var SampleAppUIFunctions_1 = require("./SampleAppUIFunctions");
var SoundFileUtilities_1 = require("./SoundFileUtilities");
var ocrLocalizationJSON = require("./../../sample-app-resources/FaceTec_OCR_Customization.json");
exports.SampleAppUtilities = (function () {
    var vocalGuidanceSoundFilesDirectory = "./../../sample-app-resources/Vocal_Guidance_Audio_Files/";
    var VocalGuidanceMode;
    (function (VocalGuidanceMode) {
        VocalGuidanceMode[VocalGuidanceMode["MINIMAL"] = 0] = "MINIMAL";
        VocalGuidanceMode[VocalGuidanceMode["FULL"] = 1] = "FULL";
        VocalGuidanceMode[VocalGuidanceMode["OFF"] = 2] = "OFF";
    })(VocalGuidanceMode || (VocalGuidanceMode = {}));
    //  var vocalGuidanceOnPlayer = new Audio(vocalGuidanceSoundFilesDirectory + "vocal_guidance_on.mp3");
    // var vocalGuidanceOffPlayer = new Audio(vocalGuidanceSoundFilesDirectory + "vocal_guidance_off.mp3");
    var vocalGuidanceOnPlayer = new Audio("/facetec/audios/vocal_guidance_on.mp3");
    var vocalGuidanceOffPlayer = new Audio("/facetec/audios/vocal_guidance_off.mp3");
    //
    vocalGuidanceOnPlayer.volume = 0.4;
    vocalGuidanceOffPlayer.volume = 0.4;
    vocalGuidanceOffPlayer.onended = function () {
        enableVocalGuidanceButtons();
    };
    vocalGuidanceOnPlayer.onended = function () {
        enableVocalGuidanceButtons();
    };
    var vocalGuidanceMode = VocalGuidanceMode.MINIMAL;
    function setVocalGuidanceMode() {
        disableVocalGuidanceButtons();
        if (!vocalGuidanceOnPlayer.paused || !vocalGuidanceOffPlayer.paused) {
            return;
        }
        var playPromise;
        switch (vocalGuidanceMode) {
            case VocalGuidanceMode.OFF:
                vocalGuidanceMode = VocalGuidanceMode.MINIMAL;
                {
                    var min = document.getElementById("vocal-guidance-icon-minimal");
                    var full = document.getElementById("vocal-guidance-icon-full");
                    var off = document.getElementById("vocal-guidance-icon-off");
                    if (min && full && off) {
                        min.style.display = "block";
                        full.style.display = "none";
                        off.style.display = "none";
                    }
                }
                playPromise = vocalGuidanceOnPlayer.play();
                if (typeof playPromise !== "undefined") {
                    playPromise.catch(function (_event) {
                        // Play failed
                    });
                }
                Config_1.Config.currentCustomization.vocalGuidanceCustomization.mode =
                    VocalGuidanceMode.MINIMAL;
                break;
            case VocalGuidanceMode.MINIMAL:
                vocalGuidanceMode = VocalGuidanceMode.FULL;
                {
                    var min = document.getElementById("vocal-guidance-icon-minimal");
                    var full = document.getElementById("vocal-guidance-icon-full");
                    var off = document.getElementById("vocal-guidance-icon-off");
                    if (min && full && off) {
                        min.style.display = "none";
                        full.style.display = "block";
                        off.style.display = "none";
                    }
                }
                playPromise = vocalGuidanceOnPlayer.play();
                if (typeof playPromise !== "undefined") {
                    playPromise.catch(function (_event) {
                        // Play failed
                    });
                }
                Config_1.Config.currentCustomization.vocalGuidanceCustomization.mode =
                    VocalGuidanceMode.FULL;
                break;
            case VocalGuidanceMode.FULL:
                vocalGuidanceMode = VocalGuidanceMode.OFF;
                {
                    var min = document.getElementById("vocal-guidance-icon-minimal");
                    var full = document.getElementById("vocal-guidance-icon-full");
                    var off = document.getElementById("vocal-guidance-icon-off");
                    if (min && full && off) {
                        min.style.display = "none";
                        full.style.display = "none";
                        off.style.display = "block";
                    }
                }
                playPromise = vocalGuidanceOffPlayer.play();
                if (typeof playPromise !== "undefined") {
                    playPromise.catch(function (_event) {
                        // Play failed
                    });
                }
                Config_1.Config.currentCustomization.vocalGuidanceCustomization.mode =
                    VocalGuidanceMode.OFF;
                break;
        }
        FaceTecSDK_1.FaceTecSDK.setCustomization(Config_1.Config.currentCustomization);
    }
    function setVocalGuidanceSoundFiles() {
        var soundFileUtilities = new SoundFileUtilities_1.SoundFileUtilities();
        Config_1.Config.currentCustomization = soundFileUtilities.setVocalGuidanceSoundFiles(Config_1.Config.currentCustomization);
        FaceTecSDK_1.FaceTecSDK.setCustomization(Config_1.Config.currentCustomization);
    }
    function setOCRLocalization() {
        // Set the strings to be used for group names, field names, and placeholder texts for the FaceTec ID Scan User OCR Confirmation Screen.
        // DEVELOPER NOTE: For this demo, we are using the template json file, 'FaceTec_OCR_Customization.json,' as the parameter in calling teh configureOCRLocalization API.
        // For the configureOCRLocalization API parameter, you may use any object that follows the same structure and key naming as the template json file, 'FaceTec_OCR_Customization.json'.
        FaceTecSDK_1.FaceTecSDK.configureOCRLocalization(ocrLocalizationJSON);
    }
    function fadeInMainUIContainer() {
        (0, SampleAppUIFunctions_1.SampleAppUIFunctions)(".loading-session-token-container").fadeOut(1);
        (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("#theme-transition-overlay").fadeOut(800);
        (0, SampleAppUIFunctions_1.SampleAppUIFunctions)(".wrapping-box-container").fadeIn(800);
        (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("footer").fadeIn(800);
    }
    function fadeInMainUIControls(callback) {
        if (isLikelyMobileDevice()) {
            (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("#custom-logo-container").fadeIn(800);
            (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("#vocal-icon-container").fadeIn(800);
        }
        (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("footer").fadeIn(800);
        (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("#controls").fadeIn(800, function () {
            enableControlButtons();
            enableVocalGuidanceButtons();
            if (typeof callback !== "undefined") {
                callback();
            }
        });
    }
    // Disable buttons to prevent hammering, fade out main interface elements, and reset the Session Review Screen data.
    function fadeOutMainUIAndPrepareForSession() {
        disableControlButtons();
        if (isLikelyMobileDevice()) {
            (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("#custom-logo-container").fadeOut(800);
            (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("#vocal-icon-container").fadeOut(800);
            disableVocalGuidanceButtons();
        }
        (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("footer").fadeOut(800);
        (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("#controls").fadeOut(800);
        (0, SampleAppUIFunctions_1.SampleAppUIFunctions)(".wrapping-box-container").fadeOut(800);
        (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("#theme-transition-overlay").fadeIn(800);
    }
    function showLoadingSessionToken() {
        (0, SampleAppUIFunctions_1.SampleAppUIFunctions)(".loading-session-token-container").fadeIn(300);
    }
    function hideLoadingSessionToken() {
        (0, SampleAppUIFunctions_1.SampleAppUIFunctions)(".loading-session-token-container").fadeOut(800);
    }
    function disableControlButtons() {
        document.querySelectorAll("#controls > button").forEach(function (button) {
            button.setAttribute("disabled", "true");
        });
    }
    function enableControlButtons() {
        document.querySelectorAll("#controls > button").forEach(function (button) {
            button.removeAttribute("disabled");
        });
        document.querySelectorAll(".vocal-icon").forEach(function (icon) {
            icon.removeAttribute("disabled");
        });
    }
    function showMainUI() {
        fadeInMainUIContainer();
        fadeInMainUIControls();
    }
    function handleErrorGettingServerSessionToken() {
        showMainUI();
        DeveloperStatusMessages_1.DeveloperStatusMessages.logAndDisplayMessage("Session could not be started due to an unexpected issue during the network request.");
    }
    function generateUUId() {
        var crypto = window.crypto || self.crypto;
        return ("" + [1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
            return (c ^
                (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16);
        });
    }
    function formatUIForDevice() {
        window.addEventListener("keydown", onKeyDown);
        if (isLikelyMobileDevice()) {
            var windowWidth = window.innerWidth;
            // Adjust button sizing
            document.querySelectorAll("button").forEach(function (element) {
                if (element.className === "big-button") {
                    element.style.height = "40px";
                    if (windowWidth <= 320) {
                        element.style.fontSize = "16px";
                    }
                    else {
                        element.style.fontSize = "18px";
                    }
                }
                else if (element.className === "medium-button") {
                    element.style.height = "30px";
                    element.style.fontSize = "14px";
                }
                element.style.width = "60%";
            });
            // Adjust main interface display (only if present in host app)
            {
                var el = document.getElementById("main-interface");
                if (el) {
                    el.style.display = "contents";
                    el.style.backgroundColor = "transparent";
                    el.style.borderColor = "transparent";
                    el.style.width = "unset";
                }
            }
            // Hide border around control panel and adjust height
            {
                var el = document.getElementById("controls");
                if (el) {
                    el.style.height = "auto";
                    el.style.backgroundColor = "transparent";
                }
            }
            // Hide status label text background and decrease label font size
            {
                var el = document.getElementById("status");
                if (el) {
                    el.style.backgroundColor = "transparent";
                    el.style.fontSize = "12px";
                    el.style.position = "inherit";
                    el.style.width = "90%";
                    el.style.margin = "0 auto";
                    el.style.bottom = "unset";
                }
            }
            // Move and update vocal guidance icon
            {
                var container = document.getElementById("vocal-icon-container");
                if (container &&
                    container.parentNode &&
                    container.parentNode.parentNode &&
                    container.parentNode.parentNode.parentNode &&
                    container.parentNode.parentNode.parentNode.parentNode) {
                    container.parentNode.parentNode.parentNode.parentNode.insertBefore(container, container.parentNode.parentNode.parentNode.parentNode
                        .firstChild);
                    document.querySelectorAll(".vocal-icon").forEach(function (icon) {
                        icon.style.height = "30px";
                        icon.style.margin = "20px";
                        icon.style.transform =
                            "translateX(calc(-100% - 40px))";
                    });
                }
            }
            // Move logo above buttons
            {
                var logo = document.getElementById("custom-logo-container");
                if (logo && logo.parentNode) {
                    logo.parentNode.insertBefore(logo, logo.parentNode.firstChild);
                    logo.style.margin = "0px 0px 20px 0px";
                    var img = document.querySelector("#custom-logo-container img");
                    if (img)
                        img.style.height = "40px";
                }
            }
            // Center control interface on screen
            {
                var wrap = document.getElementsByClassName("wrapping-box-container")[0];
                if (wrap) {
                    wrap.style.top = "50%";
                    wrap.style.left = "50%";
                    wrap.style.transform = "translate(-50%, -50%)";
                }
            }
            // Adjust button margins
            {
                var liv = document.getElementById("liveness-button");
                var design = document.getElementById("design-showcase-button");
                if (liv)
                    liv.style.marginTop = "unset";
                if (design)
                    design.style.marginBottom = "unset";
            }
            // Setup footer sizing
            var footerFontSize = "100%";
            if (windowWidth < 768) {
                footerFontSize = "9px";
            }
            if (windowWidth < 415) {
                footerFontSize = "8px";
            }
            if (windowWidth <= 360) {
                footerFontSize = "7px";
            }
            (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("footer").css({
                "font-size": footerFontSize,
                "line-height": "9px",
            });
            (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("footer span p").css({ "font-size": "inherit" });
            (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("footer span, footer span p").css({ margin: 0 });
            {
                var hr = document.querySelector("hr");
                var footerSpanP = document.querySelector("footer span p");
                if (hr)
                    hr.classList.remove("display-none");
                if (footerSpanP) {
                    var computedFooterFontSize = window.getComputedStyle(footerSpanP).fontSize;
                    (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("#copy-right-length").css({
                        "font-size": computedFooterFontSize,
                    });
                    var copyLen = document.getElementById("copy-right-length");
                    if (copyLen)
                        (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("hr").css({
                            width: copyLen.clientWidth + "px",
                        });
                }
            }
            // Allow time for the UI to fully load before fading in the body
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    displayElementsAfterStyling();
                });
            });
        }
        else {
            displayElementsAfterStyling();
        }
    }
    var keyboardAccessibilityStylingOn = false;
    function onKeyDown(e) {
        if (e.key === "Tab") {
            enableKeyboardAccessibilityStyling(true);
        }
    }
    function enableKeyboardAccessibilityStyling(enable) {
        // Mobile not supported
        if (isLikelyMobileDevice() || keyboardAccessibilityStylingOn) {
            return;
        }
        keyboardAccessibilityStylingOn = true;
        var buttons = document.getElementsByClassName("ft-button");
        for (var i = 0; i < buttons.length; i++) {
            var element = buttons[i];
            if (enable) {
                element.style.outline = "revert";
            }
            else {
                element.style.outline = "none";
            }
        }
    }
    function displayElementsAfterStyling() {
        document.querySelectorAll("button").forEach(function (element) {
            element.classList.add("button-transitions");
        });
        (0, SampleAppUIFunctions_1.SampleAppUIFunctions)("body").fadeIn(800);
    }
    function disableVocalGuidanceButtons() {
        document.querySelectorAll(".vocal-icon").forEach(function (button) {
            button.setAttribute("disabled", "true");
        });
    }
    function enableVocalGuidanceButtons() {
        document.querySelectorAll(".vocal-icon").forEach(function (button) {
            button.removeAttribute("disabled");
        });
    }
    function isLikelyMobileDevice() {
        var isMobileDeviceUA = !!/Android|iPhone|iPad|iPod|IEMobile|Mobile|mobile/i.test(navigator.userAgent || "");
        // ChromeOS/Chromebook detection.
        if (isMobileDeviceUA &&
            (navigator.userAgent.indexOf("CrOS") !== -1 ||
                navigator.userAgent.indexOf("Chromebook") !== -1)) {
            isMobileDeviceUA = false;
        }
        // Mobile device determination based on portrait / landscape and user agent.
        if (screen.width < screen.height || isMobileDeviceUA) {
            // Assume mobile device when in portrait mode or when determined by the user agent.
            return true;
        }
        else {
            return false;
        }
    }
    function disableAllButtons() {
        [
            "enroll-button",
            "id-scan-button",
            "photo-id-scan-button",
            "liveness-button",
            "authenticate-button",
            "audit-trail-button",
            "design-showcase-button",
        ].forEach(function (id) {
            var el = document.getElementById(id);
            if (el)
                el.setAttribute("disabled", "true");
        });
    }
    function enableAllButtons() {
        [
            "enroll-button",
            "id-scan-button",
            "photo-id-scan-button",
            "liveness-button",
            "authenticate-button",
            "audit-trail-button",
            "design-showcase-button",
        ].forEach(function (id) {
            var el = document.getElementById(id);
            if (el)
                el.removeAttribute("disabled");
        });
    }
    function fadeInBlurOverlay() {
        {
            var el = document.getElementById("controls");
            if (el)
                el.classList.add("blur-content");
        }
    }
    function fadeOutBlurOverlay() {
        var el = document.getElementById("controls");
        if (el && el.classList.contains("blur-content")) {
            el.classList.remove("blur-content");
        }
    }
    function showAuditTrailImages(sessionResult, idScanResult) {
        var auditTrailImages = [];
        // Add available audit trail images.
        if (sessionResult != null &&
            sessionResult.auditTrail != null &&
            sessionResult.auditTrail.length > 0) {
            // Add the regular audit trail images
            sessionResult.auditTrail.forEach(function (image) {
                auditTrailImages.push("data:image/jpeg;base64," + image);
            });
        }
        if (idScanResult != null &&
            idScanResult.frontImages != null &&
            idScanResult.frontImages.length > 0) {
            // Add ID Scan Front images
            auditTrailImages.unshift("data:image/jpeg;base64," + idScanResult.frontImages[0]);
        }
        if (idScanResult != null &&
            idScanResult.backImages != null &&
            idScanResult.backImages.length > 0) {
            // Add ID Scan Back images
            auditTrailImages.unshift("data:image/jpeg;base64," + idScanResult.backImages[0]);
        }
        if (auditTrailImages.length > 0) {
            disableAllButtons();
            fadeInBlurOverlay();
            auditTrailImages.forEach(function (img) {
                addDismissibleImagePopUp(img);
            });
        }
        else {
            DeveloperStatusMessages_1.DeveloperStatusMessages.logAndDisplayMessage("No Audit Trail Images");
        }
    }
    function addDismissibleImagePopUp(img) {
        var auditTrailOverlay = document.createElement("div");
        var auditTrailImage = new Image();
        auditTrailImage.src = img;
        auditTrailImage.classList.add("audit-trail-image");
        auditTrailOverlay.classList.add("audit-trail-overlay");
        auditTrailOverlay.onclick = function () {
            if (document.querySelectorAll(".audit-trail-overlay").length === 1) {
                fadeOutBlurOverlay();
                auditTrailOverlay.style.transition = "0.3s";
                auditTrailOverlay.style.opacity = "0";
                var _this = this;
                setTimeout(function () {
                    enableAllButtons();
                    _this.remove();
                }, 500);
            }
            else {
                this.remove();
            }
        };
        auditTrailOverlay.append(auditTrailImage);
        var ctrl = document.getElementById("controls");
        if (ctrl)
            ctrl.append(auditTrailOverlay);
    }
    return {
        setVocalGuidanceSoundFiles: setVocalGuidanceSoundFiles,
        setVocalGuidanceMode: setVocalGuidanceMode,
        setOCRLocalization: setOCRLocalization,
        fadeInMainUIContainer: fadeInMainUIContainer,
        fadeInMainUIControls: fadeInMainUIControls,
        fadeOutMainUIAndPrepareForSession: fadeOutMainUIAndPrepareForSession,
        disableControlButtons: disableControlButtons,
        enableControlButtons: enableControlButtons,
        generateUUId: generateUUId,
        formatUIForDevice: formatUIForDevice,
        showMainUI: showMainUI,
        hideLoadingSessionToken: hideLoadingSessionToken,
        showLoadingSessionToken: showLoadingSessionToken,
        isLikelyMobileDevice: isLikelyMobileDevice,
        UI: SampleAppUIFunctions_1.SampleAppUIFunctions,
        showAuditTrailImages: showAuditTrailImages,
        handleErrorGettingServerSessionToken: handleErrorGettingServerSessionToken,
    };
})();
